import { MobileAccounts } from '../../../backbone-unorganized/models';
import { EmptyListMessage } from './EmptyListMessage';
import { BaseTypeaheadModal, BaseTypeaheadHTMLItem } from './typeaheads';

export const SelectAccountModal = BaseTypeaheadModal.extend({
    collection: null, // MobileAccounts
    form_collection: null,
    toolbarnav_title: function () {
        return _t('mobile_toolbarnav_title_select_location');
    },
    focus_search_on_open: false, // usually the account of interest will be near the top of the list
    form_field_model: null, // the account field we're on, if we are on one
    itemView: BaseTypeaheadHTMLItem,
    events: _.extend(
        {
            'click .add_account': 'click_add_account'
        },
        BaseTypeaheadModal.prototype.events
    ),

    format_result: function (model) {
        const distance_section = model.get('distance') ? model.get('distance').toFixed(1) + ' mi' : '';
        const location_name_template = _.template(
            "<div class='listitem_title'><%- location_name %></div> <div class='clear'></div> <div class='listitem_distance'><%- distance_section %></div> <div class='listitem_subtitle'><%- address %></div>"
        );
        return location_name_template({
            location_name: model.get('name'),
            distance_section: distance_section,
            address: model.get('address')
        });
    },

    getEmptyView: function () {
        return EmptyListMessage.extend({
            icon_class: 'df-location',
            i18n_key_message: 'mobile_empty_list_message_no_accounts'
        });
    },

    initialize: function (options) {
        options = options || {};
        $.extend(this, options);

        if (this.is_historic_view) {
            this.default_value = this.collection.paginator.get('search_query');
        }

        // Determine tag_id if available
        var tag_id = null;
        try {
            tag_id = this.form_field_model.get('options')[0]; // get first value of array, only support one as of Dec 2013
        } catch (e) {
            // No worries, this is not required
        }

        var allow_cross_company_access = false;

        if (this.form_collection && this.form_collection.metadata.get('allow_auditors_access_locations') === true) {
            allow_cross_company_access = true;
        }

        this.collection =
            this.collection ||
            new MobileAccounts([], {
                tag_id: tag_id,
                form_collection: this.form_collection,
                allow_cross_company_access: allow_cross_company_access
            });

        SelectAccountModal.__super__.initialize.apply(this, arguments);
    }
});
